<template>
  <div id="item-contens">
    <table class="dateTable" style="width:930px;">
      <tr><th style="width:70px;"> </th><th style="width:130px;">完了日</th><th>操作者</th><th class="h-center" style="width:300px;">詳細</th></tr>
      <tr v-for="(history, index) in statusHistory" :key="index">
        <th style="padding-left:0px; vertical-align: middle;">{{getStatus(history.status)}}  </th>
        <td>{{history.completionDate}}</td>
        <td>{{history.operatorName}} ({{history.operatorBelongs}})</td>
        <td style="padding:5px; vertical-align: middle;">
          <textarea v-if="history.memo" v-model="history.memo" readonly style="height: 50px; resize: vertical;"></textarea>
        </td>
      </tr>
    </table>
  </div>
</template>
<script>
export default {
  name: "HistoryDetail",
  props:{
    statusHistory: []
  },
  methods: {
    getStatus: function(value) {
      return this.convStatus(value)
    },
  },
  data() {
    return {
      reason: ""
    };
  },
  filters: {},
  components: {},
};
</script>
<style lang="scss" scoped>
table.dateTable td {
  padding-left: 10px;
  word-break: break-all ;
}
table.dateTable th {
  text-align: center;
  vertical-align: top;
}
table.dateTable th,
table.dateTable tr,
table.dateTable td {
  border: 1px solid;
  vertical-align: middle;
}
table.dateTable {
  border-collapse: collapse;
  table-layout: fixed;
}
.h-center {
  padding-left: 0 !important;
  text-align: center; 
  margin-left: auto;
  margin-right: auto;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/common/HistoryDetail.vue